import { AdvisorSpecializationKey } from "web_myplann/Advisor/Types/AdvisorSpecializationKey";
import type { AgentSpecializationResponseDTO } from "web_myplann/Infrastructure/Api/Api";

const isAdvisorSpecializationKey = (
	key: string,
): key is AdvisorSpecializationKey =>
	Object.values<string>(AdvisorSpecializationKey).includes(key);

export const getAdvisorSpecializationKeys = (
	specializations: AgentSpecializationResponseDTO[],
) => specializations.map(({ key }) => key).filter(isAdvisorSpecializationKey);
